import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject, HostListener } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { LinkService } from '../../_services/langhfre.service';
declare function ire(string,{}): any;
@Component({
  selector: 'app-trinka-vs-languagetool',
  templateUrl: './trinka-vs-languagetool.component.html',
  styleUrls: ['./trinka-vs-languagetool.component.scss']
})
export class TrinkaVsLanguagetoolComponent implements OnInit {
  userDateSelect: Date;
  grammarlySelect: string = "";
  getUserDate: any;
  finalTextContent: boolean = false;
  compareTrinkaGrammarly: FormGroup;
  disabledSubmitButton: boolean = true;
  userEmailId: any;

  constructor(private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private formBuilder: FormBuilder,
    private fb: FormBuilder,
    private LinkService: LinkService
  ) {
    this.compareTrinkaGrammarly = fb.group({
      'userEmailId': ['', Validators.compose([Validators.required, Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/)])]
    });
  }
  @HostListener('input') oninput() {
    if (this.compareTrinkaGrammarly.valid) {
      this.disabledSubmitButton = false;
    }
  }
  ngOnInit() {
    this.titleService.setTitle('모든 언어 툴을 대신할 수 있는 AI 기반의 온라인 문법 검사 툴 - 트링카');
    this.metaTagService.updateTag({ name: 'description', content: '어드밴스 영어 문법 수정 및 개선에 적합한 AI 기반의 온라인 문법 검사 툴로 학술 및 글쓰기 기술에 전문화되어 있습니다. ' });
    this.metaTagService.updateTag({ property: 'og:title', content: '모든 언어 툴을 대신할 수 있는 AI 기반의 온라인 문법 검사 툴 - 트링카' });
    this.metaTagService.updateTag({ property: 'og:description', content: '어드밴스 영어 문법 수정 및 개선에 적합한 AI 기반의 온라인 문법 검사 툴로 학술 및 글쓰기 기술에 전문화되어 있습니다. ' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/kr/trinka-vs-languagetool' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: '모든 언어 툴을 대신할 수 있는 AI 기반의 온라인 문법 검사 툴 - 트링카' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "어드밴스 영어 문법 수정 및 개선에 적합한 AI 기반의 온라인 문법 검사 툴로 학술 및 글쓰기 기술에 전문화되어 있습니다. " });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'ko-kr' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/kr/trinka-vs-languagetool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/trinka-vs-languagetool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/trinka-vs-languagetool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/trinka-vs-languagetool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/trinka-vs-languagetool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/trinka-vs-languagetool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/trinka-vs-languagetool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/trinka-vs-languagetool' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/trinka-vs-languagetool' });
    if (isPlatformBrowser(this.platformId)) {
      $.getScript('../../../assets/js/wisepop.js', function () { });
    }
    
  }
  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }

  diffDays: any = 0;
  currentDate = new Date();
  getdifference() {
    if (typeof this.userDateSelect == "undefined" || this.grammarlySelect == "") {
      this.diffDays = 0
      return;
    } else {
      let currentDate = new Date();
      let diffTime;
      if (this.grammarlySelect == "Y") {
        let yearDate = new Date(this.userDateSelect.getFullYear() + 1, this.userDateSelect.getMonth(), this.userDateSelect.getDate());
        diffTime = Math.abs(yearDate.getTime() - this.userDateSelect.getTime());
      } else if (this.grammarlySelect == "M") {
        let monthDate = new Date(this.userDateSelect.getFullYear(), this.userDateSelect.getMonth(), this.userDateSelect.getDate() + 30);
        diffTime = Math.abs(monthDate.getTime() - this.userDateSelect.getTime());
      }
      let ext_days;
      ext_days = Math.ceil((this.userDateSelect.getTime() - currentDate.getTime()) / (1000 * 60 * 60 * 24));

      this.diffDays = (Math.ceil(diffTime / (1000 * 60 * 60 * 24))) + ext_days;
    }
  }

  premiumDateChanged(event) {
    this.userDateSelect = new Date(event.target.valueAsNumber);
    this.getdifference();
  }

  planTypeChanged(event) {
    console.log(event);
    this.grammarlySelect = event.target.value;
    this.getdifference();
    if(this.grammarlySelect== ''){
      this.finalTextContent = false;  
    }
    else{
      this.finalTextContent = true;  
    }
  }

  onSubmitEmail() {
    if (this.compareTrinkaGrammarly.valid) {
      var CloudURL = "https://cloud.trinka.ai/signup/";
      // var CloudURL = "http://localhost:4201/signup/";
      this.userEmailId = this.compareTrinkaGrammarly.value.userEmailId;
      window.location.href = CloudURL + getEncodedEmailId(this.userEmailId);
    }
  }

  generateGuid() {
    var result, i, j;
    result = '';
    for(j=0; j<32; j++) {
      if( j == 8 || j == 12 || j == 16 || j == 20)
        result = result + '-';
      i = Math.floor(Math.random()*16).toString(16).toUpperCase();
      result = result + i;
    }
    return result;
  }
}

function getEncodedEmailId(userEmailId) {
  return encodeURIComponent(btoa(userEmailId));
}

